import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Drawer, ToggleButton, ToggleButtonGroup } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import CustomInput from 'components/CustomInput/customInput';
import CustomSelect from 'components/CustomSelect/customSelect';
import CustomSelectSeach from 'components/CustomSelectSearch';
import _ from 'lodash';
import React from 'react';
import { useDispatch } from 'react-redux';
import { jobFilterData } from 'store/reducers/UserReducer';
import { USER_JOB_FILTER_DATA, USER_RELOAD } from 'store/types/UserTypes';

import useStyles from '../../pages/private/PrivateStyle';

type Props = {
  openfilter: boolean;
  setOpenFilter: (open: boolean) => void;
  tabSearch: string;
  jobFilter: any;
  workStatusList: any;
  users: any;
  setTabSearch: (tabSearch: string) => void;
  resetFilter: () => void;
};
export const JobQueueFilter = (props: Props) => {
  const {
    openfilter,
    setOpenFilter,
    tabSearch,
    jobFilter,
    workStatusList,
    users,
    setTabSearch,
    resetFilter,
  } = props;
  const dispatch = useDispatch();
  const classes = useStyles();

  const filterEdit = (key: string, val: any, type?: string) => {
    if (type === 'payRate') {
      dispatch({
        payload: {
          ...jobFilter,
          payRangeFrom: val[0].toString(),
          payRangeTo: val[1].toString(),
        },
        type: USER_JOB_FILTER_DATA,
      });
    } else {
      dispatch({
        payload: {
          ...jobFilter,
          [key]: val,
        },
        type: USER_JOB_FILTER_DATA,
      });
    }
  };
  const applyFilter = () => {
    if (!_.isEqual(jobFilterData, jobFilter)) {
      // setJobFilterState({
      //   ...jobFilter,
      //   applyFilter: true,
      // });
      filterEdit('applyFilter', true);
      dispatch({
        type: USER_RELOAD,
      });
    }
    setOpenFilter(false);
  };

  const handleSearchChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string,
  ) => {
    event.stopPropagation();
    if (newAlignment) {
      filterEdit('title', '');
      setTabSearch(newAlignment);
    }
  };

  return (
    <Drawer
      className="filter-drawer"
      open={openfilter}
      anchor={'right'}
      onClose={() => setOpenFilter(false)}>
      <Typography className="dra-title ">Filter</Typography>
      <form>
        <Grid container>
          <Grid item md={12} sm={12} className="px-12">
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                className={classes.Raterow}>
                <label className="dra-f-title">Rate</label>

                <ToggleButtonGroup
                  // color="primary"
                  value={tabSearch}
                  exclusive
                  onChange={handleSearchChange}
                  aria-label="Platform">
                  <ToggleButton
                    value="1"
                    sx={{
                      background:
                        tabSearch === '1'
                          ? '#636366 !important'
                          : 'rgba(118,118,128,0.24)',
                      border: '0px',
                      color: 'white !important',
                      fontSize: '13px',
                      fontWeight: 'bold',
                      height: '30px',
                      justifyContent: 'center',
                      paddingTop: '13px',
                      textTransform: 'capitalize',
                    }}>
                    Hourly
                  </ToggleButton>
                  <ToggleButton
                    value="2"
                    sx={{
                      background:
                        tabSearch === '2'
                          ? '#636366 !important'
                          : 'rgba(118,118,128,0.24)',
                      border: '0px',
                      color: 'white !important',
                      fontSize: '13px',
                      fontWeight: 'bold',
                      height: '30px',
                      justifyContent: 'center',
                      paddingTop: '13px',
                      textTransform: 'capitalize',
                      width: '85px',
                    }}>
                    Salary
                  </ToggleButton>
                </ToggleButtonGroup>
              </AccordionSummary>
              <AccordionDetails className={classes.accordianpadding}>
                {tabSearch === '1' ? (
                  <Slider
                    track="inverted"
                    min={15}
                    step={1}
                    max={150}
                    aria-labelledby="track-inverted-range-slider"
                    valueLabelDisplay="auto"
                    defaultValue={[
                      jobFilter.payRangeFrom
                        ? parseInt(jobFilter.payRangeFrom)
                        : 0,
                      jobFilter.payRangeTo ? parseInt(jobFilter.payRangeTo) : 0,
                    ]}
                    value={[
                      jobFilter.payRangeFrom
                        ? parseInt(jobFilter.payRangeFrom)
                        : 0,
                      jobFilter.payRangeTo ? parseInt(jobFilter.payRangeTo) : 0,
                    ]}
                    onChange={(e, data) => {
                      filterEdit('payRate', data, 'payRate');
                      // setJobFilterState({
                      //   ...jobFilter,
                      //   payRangeFrom: data[0].toString(),
                      //   payRangeTo: data[1].toString(),
                      // });
                    }}
                    marks={[
                      {
                        label: '$15',
                        value: 15,
                      },
                      {
                        label: '$150',
                        value: 150,
                      },
                    ]}
                  />
                ) : (
                  <Typography className={classes.Ratedescription}>
                    <CustomInput
                      placeHolder="$100,00"
                      // value={'$' + value}
                      name={'salarystart'}
                      className={classes.custominput}
                      value={'$ ' + jobFilter.salaryFrom}
                      onChange={(e: any) => {
                        // onChange(
                        //   e?.target?.value.replace(/[^0-9]+/g, ''),
                        // );
                        filterEdit(
                          'salaryFrom',
                          Number(e?.target?.value.replace(/[^0-9]+/g, '')),
                        );
                      }}
                    />
                    <CustomInput
                      placeHolder="$125,000"
                      // value={'$' + value}
                      name={'salaryend'}
                      className={classes.custominput}
                      value={'$ ' + jobFilter.salaryTo}
                      onChange={(e: any) => {
                        // onChange(
                        //   e?.target?.value.replace(/[^0-9]+/g, ''),
                        // );
                        filterEdit(
                          'salaryTo',
                          Number(e?.target?.value.replace(/[^0-9]+/g, '')),
                        );
                      }}
                    />
                  </Typography>
                )}
              </AccordionDetails>
            </Accordion>
            <Typography className="border" />
          </Grid>
          <Grid item md={12} sm={12} className="px-12">
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header">
                <label className="dra-f-title">Skills</label>
              </AccordionSummary>
              <AccordionDetails>
                <CustomSelectSeach
                  value={{}}
                  onChange={(e) => {
                    if (e) {
                      const fIdx = jobFilter.skillData.findIndex(
                        (item) => item.id === e.id,
                      );
                      if (fIdx === -1) {
                        filterEdit('skillData', [...jobFilter.skillData, e]);
                        // setJobFilterState({
                        //   ...jobFilter,
                        //   ['skillData']: [e],
                        // });
                      }
                    }
                  }}
                  type={'multiple'}
                  className={'skill-job-select'}
                />
                <Typography
                  component={'div'}
                  className="d-flex-a"
                  sx={{ flexWrap: 'wrap' }}>
                  {jobFilter.skillData && jobFilter.skillData.length ? (
                    jobFilter.skillData.map((item: any, index: number) => {
                      return (
                        <Typography className="search-item" key={index}>
                          {item?.name}
                          <Typography
                            onClick={() => {
                              // setJobFilterState({
                              //   ...jobFilter,
                              //   ['skillData']:
                              //     jobFilterState.skillData.filter(
                              //       (row: any) =>
                              //         row.id !== item?.id,
                              //     ),
                              // });
                              filterEdit(
                                'skillData',
                                jobFilter.skillData.filter(
                                  (row: any) => row.id !== item?.id,
                                ),
                              );
                            }}>
                            <CloseIcon />
                          </Typography>
                        </Typography>
                      );
                    })
                  ) : (
                    <Typography />
                  )}
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Typography className="border" />
          </Grid>
          ;
          <Grid item md={12} sm={12} className="px-12">
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header">
                <label className="dra-f-title">Location</label>
              </AccordionSummary>
              <AccordionDetails>
                <CustomInput
                  placeHolder=""
                  // variant="outlined"
                  onChange={(e) => {
                    filterEdit('location', e?.target?.value);
                    // setJobFilterState({
                    //   ...jobFilter,
                    //   ['location']: e?.target?.value,
                    // });
                  }}
                  value={jobFilter.location}
                  className={classes.custominput}
                />
              </AccordionDetails>
            </Accordion>
            <Typography className="border" />
          </Grid>
          <Grid item md={12} sm={12}>
            <Typography className="row-pad">
              <label className="dra-f-title">Job Title</label>
              <CustomInput
                placeHolder=""
                // variant="outlined"
                onChange={(e) => {
                  filterEdit('title', e?.target?.value);
                  // setJobFilterState({
                  //   ...jobFilter,
                  //   ['title']: e?.target?.value,
                  // });
                }}
                value={jobFilter.title}
                className={classes.custominput}
              />
            </Typography>
            <Typography className="row-pad">
              <label className="dra-f-title">Work Status</label>
              <CustomSelect
                onChange={(e: any) => {
                  filterEdit('workStatus', e?.target?.value);
                  // setJobFilterState({
                  //   ...jobFilter,
                  //   ['workStatus']: e?.target?.value,
                  // });
                }}
                value={jobFilter?.workStatus}
                labelKey={'name'}
                valueKey={'id'}
                options={workStatusList}
                placeHolder={''}
                className={'common-select'}
              />
              {/* <Typography className="border mt-50" /> */}
            </Typography>
            <Typography className="row-pad">
              <label className="dra-f-title">Sales Person</label>
              <CustomSelect
                value={jobFilter?.assignedTo}
                type="search"
                searchable={true}
                labelKey={'firstName'}
                label1Key={'lastName'}
                valueKey={'id'}
                options={users}
                placeHolder={''}
                className={'common-select'}
                onChange={(e: any) => {
                  filterEdit('assignedTo', e?.target?.value);
                }}
              />
              <Typography className="border" />
            </Typography>
            <Typography className="row-pad">
              <label className="dra-f-title">Created by</label>
              <CustomSelect
                value={jobFilter?.assignedBy}
                type="search"
                searchable={true}
                labelKey={'firstName'}
                label1Key={'lastName'}
                valueKey={'id'}
                options={users}
                placeHolder={''}
                className={'common-select'}
                onChange={(e: any) => {
                  filterEdit('assignedBy', e?.target?.value);
                }}
              />
              <Typography className="border mt-50" />
            </Typography>
          </Grid>
          <Grid item md={12} sm={12}>
            <Typography
              className="d-flex-a flex-sb"
              sx={{ padding: '15px 12px' }}>
              <Button className="m-blue-btn mr-8" onClick={resetFilter}>
                Reset
              </Button>
              <Button className="m-blue-btn" onClick={applyFilter}>
                Apply
              </Button>
            </Typography>
          </Grid>
        </Grid>
      </form>{' '}
    </Drawer>
  );
};

export default JobQueueFilter;
